import { render } from "./ResetPage.vue?vue&type=template&id=61907b19"
import script from "./ResetPage.vue?vue&type=script&lang=js"
export * from "./ResetPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__